
import { Container, Typography } from "@mui/material";



const About = () => {

    return (

        <Container>
            <Typography variant="h1">About</Typography>
            <Typography variant="body">Our friendly neighborhood journaling app</Typography>
        </Container >
    );
};

export default About;